import React from "react";
import Login from "./Login";

function Home() {
  return (
    <main className="grange-auth-screen">
      <video className="grange-auth-video" autoPlay muted loop playsInline>
        <source src="/grange.mp4" type="video/mp4" />
      </video>

      <div className="grange-auth-overlay"></div>

      <section className="grange-auth-content">
        <div className="grange-auth-left">
          <div className="grange-left-panel">
            <div className="grange-school-pill">
              THE GRANGE CHRISTIAN SCHOOL
            </div>

            <p className="grange-portal-label">
              Unified School & E-learning Portal
            </p>

            <h1 className="grange-hero-heading">
              <span className="grange-hero-growing">Growing minds.</span>
              <span className="grange-hero-future">Shaping futures.</span>
            </h1>

            <p className="grange-auth-intro">
              A secure digital gateway for lessons, assignments, attendance,
              results, parent updates and school communication.
            </p>

            <div className="grange-feature-grid">
              <div>
                <strong>01</strong>
                <span>Student learning access</span>
              </div>
              <div>
                <strong>02</strong>
                <span>Parent progress tracking</span>
              </div>
              <div>
                <strong>03</strong>
                <span>Staff academic workspace</span>
              </div>
              <div>
                <strong>04</strong>
                <span>Online resources & quizzes</span>
              </div>
            </div>
          </div>
        </div>

        <div className="grange-auth-card">
          <Login />
        </div>
      </section>

      
    </main>
  );
}

export default Home;